import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfColor } from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { OptsImage } from '../optsImage';
import { IItemCount } from '@educraft/base';
import { GUtil } from '../../pdf/gutil';
import { drawDitherLogo } from '../../pdf/ditherLogo';
import '../../pdf/draw/primitives';
import '../../pdf/draw/image';
import '../../pdf/draw/cut';
import '../../pdf/draw/string';

/**
 * Pexeso - Memory matching cards
 *
 * Layout: Multiple portrait pages with front sides + 1 back side.
 * - Front pages: 4×5 grid (20 cells), each image appears twice in same row
 * - Back page: DitherLogo "PEXESO" pattern
 *
 * Number of front pages = Math.ceil(count / 10)
 *
 * Migrated from C# EduFrame.Img10.Generators.Pexeso
 */
export class Pexeso implements ILayoutImageGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 2;
  }
  countMax(): number {
    return 50;
  }

  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const seed = opts.data.random.next(0, 2147483647);

    const cardW = PdfUnit.FromMillimeters(50);
    const cardH = PdfUnit.FromMillimeters(50);

    const cols = 4;
    const rows = 5;
    const itemsPerPage = (cols * rows) / 2;
    const numPages = Math.ceil(opts.list.length / itemsPerPage);

    const originX = (PdfSize.A4.width - cols * cardW) / 2;
    const originY = (PdfSize.A4.height - rows * cardH) / 2;

    for (let page = 0; page < numPages; page++) {
      const pageObj = pdf.addPage();

      for (let row = 0; row < rows; row++) {
        for (let pair = 0; pair < cols / 2; pair++) {
          const itemIndex = page * itemsPerPage + row * (cols / 2) + pair;
          if (itemIndex >= opts.list.length) break;

          const item = opts.list[itemIndex];

          for (let dup = 0; dup < 2; dup++) {
            const col = pair * 2 + dup;
            const rect = new PdfRect(originX + col * cardW, originY + row * cardH, cardW, cardH);

            pageObj.drawImageCenter(item.image, rect);
            pageObj.drawRectangle(GUtil.cutPen, null, rect);
          }
        }
      }
    }

    const backPage = pdf.addPage();
    for (let row = 0; row < rows; row++) {
      for (let pair = 0; pair < cols / 2; pair++) {
        const itemIndex = row * (cols / 2) + pair;
        if (itemIndex >= opts.list.length) break;

        for (let dup = 0; dup < 2; dup++) {
          const col = pair * 2 + dup;
          const rect = new PdfRect(originX + col * cardW, originY + row * cardH, cardW, cardH);

          await drawDitherLogo(
            backPage,
            'PEXESO',
            PdfColor.fromRgb(0, 0, 0),
            rect,
            seed,
            false,
            12,
            1
          );
          // backPage.drawRectangle(GUtil.cutPen, null, rect);
        }
      }
    }
  }
}
